"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Holder = void 0;
var Holder_1 = require("./Holder");
Object.defineProperty(exports, "Holder", { enumerable: true, get: function () { return Holder_1.Holder; } });
